<template>
  <div class="content" @touchmove.prevent>
    <Header :title="title" @toBack="toBack"></Header>
    <div
      :class="{
        box: true,
        box1: isStep == 1,
        box2: isStep == 2,
      }"
    >
      <!-- 通过邮箱号注册 -->
      <div class="step1" v-if="isStep == 1">
        <!-- 邮箱注册 -->
        <div class="selectBox" @touchmove.stop>
          <el-autocomplete
            class="emailReg"
            :popper-append-to-body="false"
            v-model="email"
            ref="emailAutoRef"
            clearable
            :fetch-suggestions="querySearchEmail"
            :trigger-on-focus="email.length > 0 ? true : false"
            placeholder="请输入邮箱号"
          >
            <div v-if="email.length > 0" slot="suffix" class="suffix-close-box">
              <svg-btn class="suffix-close" icon-class="icon-close-0"></svg-btn>
            </div>
          </el-autocomplete>
        </div>
        <div class="emailInfo" @click="drawer = true">
          <svg-btn class="iconInfo" icon-class="icon-close-1"></svg-btn>
          <span class="infoFont">查看支持注册的邮箱号</span>
        </div>
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnOne"
          round
          size="medium"
          @click="stepOne"
          >下一步</fm-button
        >
        <div class="bottomBox">
          <svg-btn
            class="check"
            @click="check = !check"
            :icon-class="check ? 'icon-short-hyes' : 'icon-short-hno'"
          />
          <div class="text">
            已详读并同意<span @click="open(91)">《用户服务协议》</span>和<span
              @click="open(86)"
              >《隐私政策》</span
            >
          </div>
        </div>
      </div>
      <!-- 验证邮箱号 -->
      <div class="step2" v-if="isStep == 2">
        <div class="topInfo">
          请输入发送至
          <span>{{ email.slice(0, 3) + '******' + email.slice(9, 11) }}</span>
          的 6 位验证码，有效期 3 分钟
        </div>
        <VerificationCode
          ref="ver"
          :isError="isError"
          :codeValue="ucode"
          @updateValue="getValue"
        >
        </VerificationCode>
        <div class="timeBox">
          <div>
            <span v-if="time === 60" @click="againGetCode(0)"
              >重新获取验证码</span
            >
            <span v-if="time < 60">{{ time }}s后重新获取</span>
          </div>
          <span v-if="time === 60 && updateGet" @click="againGetCode(2)"
            >未收到验证码？</span
          >
        </div>
        <div class="btBox">
          <fm-button
            class="loginBt"
            type="primary"
            :disabled="btnTwo"
            round
            size="medium"
            @click="stepTwo"
            >确定</fm-button
          >
        </div>
      </div>
      <!-- 设置账号/密码 -->
      <div class="step3" v-if="isStep == 3">
        <div class="font1">设置账号</div>
        <FmInput
          v-model="username"
          class="loginInput"
          placeholder="请设置Feemoo账号（6-20位数字或字母）"
          clearable
        ></FmInput>
        <div class="font2">设置密码</div>
        <FmInput
          style="margin-bottom: 12px"
          v-model="password"
          class="loginInput"
          placeholder="请设置登录密码（至少6位数字或字母）"
          type="password"
          clearable
        ></FmInput>
        <FmInput
          v-model="cpassword"
          class="loginInput"
          placeholder="请再次输入密码"
          type="password"
          clearable
        ></FmInput>
        <div class="font2" v-if="zone_switch == 1">选择区服</div>
        <el-select
          class="loginSelect"
          placeholder="请选择区服"
          v-model="zone_id"
          v-if="zone_switch == 1"
        >
          <el-option
            v-for="item in zone_config"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="font3" v-if="zone_switch == 1"
          >我们将遵照账号区服当地法律提供服务，一旦确定不可更改</span
        >
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnThree"
          :loading="loading"
          round
          size="medium"
          @click="stepThree"
          >确定</fm-button
        >
      </div>
    </div>
    <wxLink
      :isShow="wxLinkShow"
      :agreement="true"
      title="提示"
      submitText="同意"
      cancelText="不同意"
      @submit="submitLink"
      @handleClose="wxLinkShow = false"
    />
    <el-drawer class="drawer" :visible.sync="drawer" direction="btt">
      <div
        :class="{
          intrtit: true,
          intrtitOne: index == 0,
        }"
        v-for="(item, index) in emailInfo"
        :key="index"
      >
        {{ item }}
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Header from '@/components/NavTopLogin/index.vue'
import VerificationCode from '@/components/VerificationCode/index.vue'
import wxLink from '@/components/Dialog/wxLink.vue'
import {
  getEmailRegisterSuffixAPI,
  sendEmailRegisterCodeAPI,
  checkEmailCodeAPI,
  emailRegisterAPI,
  LoginSSOAPI,
  getZoneIdConfigAPI,
} from '@/axios/login'

export default {
  name: 'emailRegister',
  components: {
    Header,
    VerificationCode,
    wxLink,
  },
  data() {
    return {
      phone: '',
      isStep: 1,
      title: '通过邮箱号注册',
      ucode: '', //验证码字段
      time: 60,
      timerA: '',
      updateGet: false,
      password: '',
      cpassword: '',
      sms_type: 0,
      wxLinkShow: false,
      check: false,
      drawer: false,
      emailSwitchData: {
        infos: {},
        suffixs: [
          '@qq.com',
          '@vip.qq.com',
          '@foxmail.com',
          '@163.com',
          '@126.com',
          '@yeah.net',
          '@vip.163.com',
          '@vip.126.com',
          '@188.com',
          '@sina.com',
          '@sina.cn',
          '@vip.sina.com',
          '@sohu.com',
          '@sohu.cn',
          '@139.com',
        ],
      },
      email: '',
      isError: false,
      fshort: '',
      username: '',
      password: '',
      cpassword: '',
      loading: false,
      zone_id: '', //区服ID
      zone_switch: 0, //区服开关
      zone_config: [], //区服list
      emailInfo: [], //支持邮箱号
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
    ucode() {
      if (this.ucode.length < 6) {
        this.isError = false
      }
    },
  },
  mounted() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    this.fshort = sessionStorage.getItem('shortFshort') || ''
    this.getZoneIdConfig()
    this.getEmailSwitch()
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    btnOne() {
      if (this.email.length > 0) {
        return false
      }
      return true
    },
    btnTwo() {
      if (this.ucode.length == 6) {
        return false
      }
      return true
    },
    btnThree() {
      if (
        this.username.trim().length >= 6 &&
        this.password.trim().length >= 6 &&
        this.cpassword.trim().length >= 6
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    getZoneIdConfig() {
      getZoneIdConfigAPI()
        .then(res => {
          if (res.status == 1) {
            this.zone_switch = res.data.zone_switch
            this.zone_config = res.data.zone_config
            const selectedZone = this.zone_config.find(
              item => item.is_select == 1
            )
            // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
            this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
          }
        })
        .catch(err => {})
    },
    stepOne: _.debounce(
      function (captcha_verify, validate = {}) {
        if (this.btnOne) {
          return
        }
        if (!this.check) {
          this.wxLinkShow = true
          return
        }
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          this.clearOp()
          let data = {
            email: this.email,
            sms_type: this.sms_type, //0是获取验证码，2是重新验证码
            captcha_verify: captcha_verify || '',
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
          }
          sendEmailRegisterCodeAPI(data)
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.msgid = res.data.msgid
                this.isStep = 2
                this.title = '验证邮箱号'
                if (this.time === 60) {
                  this.timerA = setInterval(() => {
                    this.minute()
                  }, 1000)
                }
                this.ucode = ''
                this.$nextTick(() => {
                  this.$refs.ver?.reset()
                })
                this.$htoast(res.msg)
              } else if (res.status == 90001) {
                this.$htoast(res.msg)
                this.$AliCode.handleOpen(this.stepOne)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  '5b0562a75492b420626b745b229e83a4',
                  this.stepOne
                )
              } else {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$htoast(res.msg)
              }
            })
            .catch(err => {})
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    clearOp() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
    stepTwo: _.debounce(
      function () {
        if (this.btnTwo) {
          return
        }
        let data = {
          email: this.email,
          msgid: this.msgid,
          ucode: this.ucode,
        }
        checkEmailCodeAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.isStep = 3
              this.title = '设置账号/密码'
            } else {
              this.isError = true
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    stepThree: _.debounce(
      function () {
        if (this.btnThree || this.loading) {
          return
        }
        let length = this.username.trim().length
        if (length < 6 || length > 20) {
          this.$htoast('Feemoo账号仅支持6-20位数字或字母，请修改')
          return
        }
        if (this.password !== this.cpassword) {
          this.$htoast('密码不一致，请重试')
          return
        }
        this.loading = true
        let data = {
          msgid: this.msgid,
          ucode: this.ucode,
          email: this.email,
          username: this.username,
          password: this.password,
          repassword: this.cpassword,
          rcode: this.fshort,
          zone_id: this.zone_id,
        }
        emailRegisterAPI(data)
          .then(res => {
            if (res.status == 1) {
              LoginSSOAPI({ token: res.data.sso[0].token }).then(res => {
                if (res.status == 1) {
                  localStorage.setItem('shortToken', res.data.authtoken)
                }
              })
              setTimeout(() => {
                this.toComplete()
              }, 600)
            } else {
              this.loading = false
              this.$htoast(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      this.loading = false
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
    submitLink() {
      this.wxLinkShow = false
      this.check = true
      this.stepOne()
    },
    minute: function () {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        this.updateGet = true
        clearInterval(this.timerA)
      }
    },
    //验证码输入回调
    getValue(newValue) {
      this.ucode = newValue
      if (this.ucode.length == 6) {
        this.stepTwo()
      }
    },
    againGetCode(row) {
      this.sms_type = row
      this.stepOne()
    },
    //清除账号密码
    clearUP() {
      this.username = ''
      this.password = ''
      this.cpassword = ''
      const selectedZone = this.zone_config.find(item => item.is_select == 1)
      // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
      this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
    },
    toBack() {
      if (this.isStep == 1) {
        this.$router.replace({ path: '/login', query: { isType: 2 } })
      } else if (this.isStep == 2) {
        this.title = '通过邮箱号注册'
        this.isStep = 1
      } else if (this.isStep == 3) {
        this.title = '验证邮箱号'
        this.isStep = 2
      }
    },
    //切换方式
    checkType(row) {
      this.email = ''
      this.phone = ''
      this.isType = row
    },
    open(num) {
      // window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      // window.open(url, '_href')
      if (this.detectBrowser()) {
        let url = this.$glb.shareUrl + '/agreement/?code=' + num
        //曲线救国，如果不设置窗口名，浏览器会限制只能开一个窗口
        const windowName = 'emailRegister' + new Date().getTime();
        window.open(url, windowName);
      } else {
        window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      }
    },
    // 兼容主流浏览器 safari Chrome Firefox
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : '';
      
      // 检测Safari
      const isSafari =
        vendor.includes('apple') &&
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') &&
        !userAgent.includes('fxios');
      
      // 检测Chrome（包括移动版Chrome）
      const isChrome =
        (userAgent.includes('chrome') || userAgent.includes('crios')) &&
        // 排除Edge浏览器（因为Edge的UA也可能包含chrome）
        !userAgent.includes('edg') &&
        !userAgent.includes('edge');
      
      // 检测Firefox（包括移动版Firefox）
      const isFirefox = 
        userAgent.includes('firefox') || 
        userAgent.includes('fxios');
      
      // 如果是其中任意一种浏览器则返回true
      return isSafari || isChrome || isFirefox;
    },
    // 邮箱自动填充后缀名
    querySearchEmail(queryString, callback) {
      var emailList = []
      emailList = this.emailSwitchData.suffixs
      let results = []
      let queryList = []
      emailList.map(item => {
        queryList.push({ value: queryString.split('@')[0] + item })
      })
      if (queryString) {
        if (this.$refs.emailAutoRef) {
          this.$refs.emailAutoRef.activated = true
        }
        results = queryString
          ? queryList.filter(this.createFilter(queryString))
          : queryList
      }
      callback(results)
    },
    // 邮箱填写过滤
    createFilter(queryString) {
      return item => {
        return item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    //获取可支持的邮箱后缀
    getEmailSwitch() {
      return new Promise(resolve => {
        getEmailRegisterSuffixAPI()
          .then(res => {
            this.emailSwitchData = res.data
            this.emailInfo = res.data.infos.map(item => {
              if (item.includes('/')) {
                return item.replace(/\//g, '\u200B/\u200B')
              }
              return item
            })
            resolve(res.data)
          })
          .catch(err => {})
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .box {
    height: 100%;
    padding: 40px 34px 0 34px;
    ::v-deep .step1 {
      display: flex;
      flex-direction: column;
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
      .selectBox {
        width: 100%;
        .emailReg {
          width: 100%;
          .el-input {
            width: 100%;
            height: 50px;
            .el-input__inner {
              width: 100%;
              height: 50px;
              border-radius: 50px;
              padding-left: 16px;
            }
          }
          .el-popper[x-placement^='bottom'] .popper__arrow {
            display: none;
          }
          .el-autocomplete-suggestion__wrap {
            height: 166px;
            padding: 6px 0 !important;
          }

          .el-autocomplete-suggestion {
            width: 100% !important;
            top: 42px !important;
            left: 0 !important;
            border-radius: 16px;
            height: 166px;
            z-index: 999 !important;
            box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.07) !important;
            border: none !important;
          }

          .el-autocomplete-suggestion li {
            padding: 0 9px;
            margin: 0 8px !important;
            border-radius: 12px;
            line-height: 40px;
            color: #2c2c2c;
            &:hover {
              background: #f6f6f6 !important;
              border-radius: 12px !important;
            }
          }

          .el-autocomplete-suggestion li:focus {
            background: #f6f6f6 !important;
            border-radius: 12px !important;
          }
          .el-input__clear {
            background: #f7f7f7 !important;
            width: 14.5px;
            position: absolute;
            right: 11px;
            opacity: 0;
          }
        }
        .suffix-close-box {
          width: 14.5px;
          height: 14.5px;
          position: absolute;
          right: 11px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
        }

        .suffix-close {
          width: 16px;
          cursor: pointer;
        }
      }
      .emailInfo {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 34px;
        top: 160px;
        .iconInfo {
          width: 10px;
          height: 10px;
        }
        .infoFont {
          font-weight: 400;
          font-size: 9px;
          color: #8a8b92;
          line-height: 18px;
          margin-left: 3px;
        }
      }
      .bottomBox {
        display: flex;
        align-items: flex-start;
        margin-top: 20px;
        .check {
          width: 14px;
          height: 14px;
          margin-right: 2px;
          margin-top: 1px;
        }
        .text {
          font-weight: 400;
          font-size: 12px;
          color: #bdbdbe;
          line-height: 16px;
          span {
            color: #2c2c2c;
          }
        }
      }
    }
    .step2 {
      .topInfo {
        font-weight: 400;
        font-size: 14px;
        color: #8a8b92;
        line-height: 20px;
        text-align: left;
        margin-bottom: 32px;
        width: 100%;
        span {
          color: #2c2c2c !important;
        }
      }
      .timeBox {
        margin-top: 24px;
        font-weight: 400;
        font-size: 14px;
        color: #f67942;
        line-height: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .btBox {
        margin-top: 32px;
        padding: 0 18px;
        .loginBt {
          width: 100%;
          height: 48px;
          border-radius: 48px;
          span {
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
          }
        }
      }
    }
    .step3 {
      display: flex;
      flex-direction: column;
      .font1 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 12px;
      }
      .font2 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-bottom: 12px;
        margin-top: 36px;
      }
      .font3 {
        font-weight: 400;
        font-size: 11px;
        color: #bdbdbe;
        line-height: 16px;
        margin-top: 4px;
        margin-left: 6px;
      }
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        margin-top: 24px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
  }
  .box1 {
    padding-top: 64px;
  }
  .box2 {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
